export function yen(v) {
  const n = Number(v || 0);
  return `¥${Math.round(n).toLocaleString("ja-JP")}`;
}

export function num(v) {
  return Number(v || 0).toLocaleString("ja-JP");
}

export function pct(v) {
  return `${Number(v || 0).toLocaleString("ja-JP")}%`;
}

export function dateJP(v) {
  if (!v) return "-";
  const d = new Date(v);
  if (isNaN(d.getTime())) return String(v).slice(0, 10);
  return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}`;
}

export function area(v) {
  if (!v && v !== 0) return "-";
  return `${Number(v).toLocaleString("ja-JP")}㎡`;
}
